var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 默认值为了对应之前的逻辑，避免少传字段
 */
export var defaultParams = {
    module_id: '',
    module_value: '',
    module_type: '',
    element_id: '',
    element_type: '',
    element_chinese_type: '',
    element_content: '',
};
export var defaultApiParams = {
    api_name: '',
    api_cost: '',
    api_result: '',
    http_code: '',
    api_server: '1', // 接口服务端，1-前端；2-后端
};
var debugChannel = {
    waring: function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray([message], optionalParams, false));
    },
    error: function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.error.apply(console, __spreadArray([message], optionalParams, false));
    },
    info: function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        console.info.apply(console, __spreadArray([message], optionalParams, false));
    },
};
export var initialOptions = {
    env: 'development',
    debug: false,
    debugChannel: debugChannel,
    stopReport: false,
};
